<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Follow Conversation</v-card-title>

        <v-card-text
            v-if="organization_id != null"
        >
            <m-autocomplete-conversation
                v-model="conversation_id"
                label="Conversation to follow"
                :organization_id="organization_id"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="conversation_id == null"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            organization_id: null,
            conversation_id: null,
        }
    },

    methods: {

        showDialog(organization_id)
        {
            this.conversation_id = null;
            this.organization_id = organization_id;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.conversation_id);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>